import { Typography } from '@mui/material';
import { createSelector } from '@reduxjs/toolkit';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { YouCanComeBackNote } from '../../../../general/components/footers/you-can-come-back-note';
import { WizardPage } from '../../../../general/components/wizard-page';
import { formatCentsCurrency } from '../../../../general/utils/formatters';
import { UbosForm } from '../../../application/components/ubos-form';
import { selectCreditTerms } from '../../../application/reducers/credit-terms.reducer';
import { selectnextStep } from '../../../application/reducers/next-step';

const selector = createSelector([selectnextStep, selectCreditTerms], (nextStep, { creditTerms }) => ({
  creditLimit: creditTerms?.finalCreditLimit,
  loading: nextStep.loading,
}));

const ReviewApplicationPage: FC = () => {
  const { creditLimit, loading } = useSelector(selector);

  return (
    !loading &&
    !!creditLimit && (
      <WizardPage
        title={
          <>
            Review your application for a <br />
            <Typography component="span" color="primary" variant="inherit">
              {formatCentsCurrency(creditLimit)}
            </Typography>{' '}
            credit limit
          </>
        }
        footer={<YouCanComeBackNote />}
      >
        <UbosForm submitLabel="Submit" attestationVerb="submitting" submitAction="get_ubos" />
      </WizardPage>
    )
  );
};

export { ReviewApplicationPage };
